(function (Drupal, $) {
  const init = () => {
    // init Freeze Table
    const freezeTables = document.querySelectorAll(".js-freeze-table");
    if (!freezeTables.length) return;

    freezeTables.forEach((table) => {
      const frozenRows = +table.dataset.frozenRows;
      const frozenColumns = +table.dataset.frozenColumns;

      if (!frozenRows && !frozenColumns) return;

      if (window.matchMedia("(min-width: 760px)").matches) {
        $(table).freezeTable({
          freezeHead: frozenRows > 0,
          freezeColumn: frozenColumns > 0,
          columnNum: frozenColumns > 0 ? frozenColumns : 0,
        });
      }
    });
  };

  function hexToRgb(hex, op) {
    var result =
      /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})|([a-f\d]{1})([a-f\d]{1})([a-f\d]{1})$/i.exec(
        hex
      );
    return result
      ? {
          r: parseInt(hex.length <= 4 ? result[4] + result[4] : result[1], 16),
          g: parseInt(hex.length <= 4 ? result[5] + result[5] : result[2], 16),
          b: parseInt(hex.length <= 4 ? result[6] + result[6] : result[3], 16),
          toString: function () {
            var arr = [];
            arr.push(this.r);
            arr.push(this.g);
            arr.push(this.b);
            return "rgb(" + arr.join(",") + "," + op + ")";
          },
        }
      : null;
  }

  var primaryColor = getComputedStyle(document.body).getPropertyValue(
    "--primary-color"
  );
  primaryColor = primaryColor.toString();
  primaryColor = primaryColor.substring(1);

  $(document).ajaxStop(function () {
    document.documentElement.style.setProperty(
      "--primary-color-light",
      hexToRgb(primaryColor, "0.2")
    );
    $("table").each(function () {
      var $this = $(this);
      var vertical = true;
      $this.find(".table__row").each(function () {
        if ($(this).children(".table__cell").length > 2) vertical = false;
        if (!$(this).children().length) $(this).remove();
      });
      if (vertical) {
        $this.removeClass(".scrollable").addClass("vertical");
      } else {
        $this
          .closest(".table_wrapper")
          .append(
            `<div class="drag-wrapper"><div class="drag">Drag</div></div>`
          );
        var generalWrapper = $this.closest(".table_wrapper");
        var wrapper1 = $this.parent();
        var wrapper2 = wrapper1.siblings(".scroll-simulator_wrapper");
        var simulator = wrapper2.children(".scroll-simulator");

        function adjustScroll(source) {
          if (source === "original") {
            $(wrapper2).scrollLeft($(wrapper1).scrollLeft());
          }
          if (source === "simulated") {
            $(wrapper1).scrollLeft($(wrapper2).scrollLeft());
          }

          if ($this.width() > wrapper1.width()) {
            wrapper2.addClass("scrolling");
          } else {
            wrapper2.removeClass("scrolling");
          }
          adjustBlur();
        }

        function adjustBlur() {
          var $width = wrapper1.outerWidth();
          var $scrollWidth = wrapper1[0].scrollWidth;
          var $scrollLeft = wrapper1.scrollLeft();
          var $offset = 10;

          $scrollWidth - $width < $scrollLeft + $offset
            ? generalWrapper.removeClass("scrollable-right")
            : generalWrapper.addClass("scrollable-right");
          $scrollLeft < $offset
            ? generalWrapper.removeClass("scrollable-left")
            : generalWrapper.addClass("scrollable-left");
        }

        simulator.width($this.width());
        adjustScroll();

        $(window).resize(function () {
          simulator.width($this.width());
          adjustScroll();
        });

        $(wrapper1).scroll(function () {
          adjustScroll("original");
          generalWrapper.find(".drag-wrapper").remove();
        });
        $(wrapper2).scroll(function () {
          adjustScroll("simulated");
        });
      }
    });
  });

  window.addEventListener("load", init);
})(Drupal, jQuery);
